import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faEllipsisV } from '@fortawesome/pro-solid-svg-icons';
import { Dropdown, Image } from 'react-bootstrap-5';
import UnstyledDropdownToggle from '../../bootstrap_extensions/bs5/unstyled_dropdown_toggle';

export default class ActiveIntegrationsCard extends React.Component {

  static propTypes = {
    children: PropTypes.node.isRequired,
    image: PropTypes.string.isRequired,
    name: PropTypes.string,
    pushContactsToSource: PropTypes.bool,
    onCancel: PropTypes.func,
    onEdit: PropTypes.func,
    onImport: PropTypes.func,
    onPush: PropTypes.func,
  }

  renderIntegrationActions() {
    const {
      pushContactsToSource,
      onEdit,
      onCancel,
      onImport,
      onPush,
    } = this.props;

    return (
      <Dropdown align="end">
        <Dropdown.Toggle
          aria-label="Integration actions"
          as={UnstyledDropdownToggle}
          className="p-0 border-0 text-decoration-none"
          variant="link"
        >
          <FontAwesomeIcon className="text-muted" icon={faEllipsisV} size="lg"/>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {onEdit &&
            <Dropdown.Item id="switch-db-btn" onClick={onEdit}>
              Switch Database
            </Dropdown.Item>
          }
          <Dropdown.Item id="disconnect-btn" onClick={onCancel}>
            Disconnect Account
          </Dropdown.Item>
          {onImport &&
            <Dropdown.Item id="import-btn" onClick={onImport}>
              Import
            </Dropdown.Item>
          }
          {(onPush && pushContactsToSource) &&
            <Dropdown.Item id="push-btn" onClick={onPush}>
              Push Contacts
            </Dropdown.Item>
          }
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  renderIntegratedButtons() {
    const { onCancel } = this.props;
    return (
      <div className="d-flex flex-row align-items-center justify-content-end gap-2">
        {this.renderConnectedBox()}
        {onCancel && this.renderIntegrationActions()}
      </div>
    );
  }

  renderConnectedBox() {
    return (
      <span className="badge text-bg-success text-uppercase d-inline-flex align-items-center gap-1 px-2 py-1">
        <FontAwesomeIcon icon={faCheck} size="sm" />
        Connected
      </span>
    );
  }

  render() {
    const {
      children,
      image,
      name
    } = this.props;

    return (
      <React.Fragment>
        <hr className="my-2"/>
        <div className="d-flex flex-column flex-md-row">
          <div className="flex-shrink-0 px-4">
            <div className="bg-body-tertiary border rounded p-2 d-inline-flex">
              <Image alt={name ? `${name} integration icon` : 'Integration icon'} height={36} src={image} width={36} />
            </div>
          </div>
          <div className="flex-grow-1">
            {children}
          </div>
          {this.renderIntegratedButtons()}
        </div>
      </React.Fragment>
    );
  }
}
